import { render, staticRenderFns } from "./BillCalculation.vue?vue&type=template&id=276a53bc&scoped=true"
import script from "./BillCalculation.vue?vue&type=script&lang=js"
export * from "./BillCalculation.vue?vue&type=script&lang=js"
import style0 from "./BillCalculation.vue?vue&type=style&index=0&id=276a53bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276a53bc",
  null
  
)

export default component.exports